import React from 'react';
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from '@mui/material';
import Icon from '../../../../components/Elements/Icon';

export const NoDataMessage = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 0',
        height: '100%',
      }}
    >
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(4),
          borderRadius: theme.spacing(1),
          backgroundColor: theme.palette.grey[50],
          maxHeight: '400px',
          maxWidth: '400px',
        }}
      >
        <Icon 
          name="NoDataFound" 
          height="100px" 
          width="100px" 
          style={{ 
            marginBottom: theme.spacing(2),
            opacity: 0.8,
          }}
        />
        <Typography 
          variant="h6" 
          color="textSecondary"
          align="center"
          sx={{ 
            fontWeight: 500,
            marginBottom: theme.spacing(1)
          }}
        >
          {t("message.noDataFound")}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
        >
          {t("message.tryAdjustingFilters")}
        </Typography>
      </Box>
    </Box>
  );
}; 